/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { CompanyService } from '../../services/company.service';
import { IPartner } from 'src/app/pages/partners/models/partner.interface';

@Component({
  selector: 'app-tab-dados-empresa',
  templateUrl: './tab-dados-empresa.component.html',
  styleUrls: ['./tab-dados-empresa.component.scss']
})
export class TabDadosEmpresaComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() formCompany!: UntypedFormGroup;
  @Input() partners!: IPartner[];

  opcoesTipoCompany: string[] = [];
  
  constructor(private readonly companyService: CompanyService) {
    this.opcoesTipoCompany = this.companyService.opcoesTipoEmpresa;
  }
}
